export class Table {
	id?: number;
	establishmentId: number;
	sector: string;
	mainIdentification: string;
	qrCode?: string;

	constructor(obj: any = { }) {
		Object.assign(this, obj);
	}
}

// tslint:disable-next-line:max-classes-per-file
export class TableListModel {
	sector: string;
	list: Array<Table>;

	constructor(sector: string, list: Array<Table>) {
		this.sector = sector;
		this.list = list;
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/store/models/table-list.model.ts